import React, { useEffect, useState, useRef } from "react";
import { Link, useSearchParams, useLocation } from "react-router-dom";
import axios from "axios";
import { API_BASE_URL } from '../config';
import { useCart } from '../CartContext';
import placeholderImage from "../images/Placeholder.png";
const placeholderURL = "https://res.cloudinary.com/dhvp4dpyn/image/upload/c_thumb,w_200,g_face/v1745429160/VtqunOBD_mg1fbw.jpg";

// https://res.cloudinary.com/dhvp4dpyn/image/upload/v1745428775/67ddb28912d825a811bbfa2e_nvj3gn.jpg
// https://res.cloudinary.com/dhvp4dpyn/image/upload/c_thumb,w_240/v1745428775/67ddb28912d825a811bbfa2e_nvj3gn.jpg
function matchSearch(query, target) {
    const normalizedQuery = query.toLowerCase();
    const normalizedTarget = target.toLowerCase();

    let queryIndex = 0;

    for (let char of normalizedTarget) {
        if (char === normalizedQuery[queryIndex]) {
            queryIndex++;
        }
        if (queryIndex === normalizedQuery.length && normalizedTarget.includes(normalizedQuery)) {
            return true;
        }
    }

    return false;
}


function Shop({ type }) {
    const { cart, addToCart, updateQuantity, removeFromCart } = useCart();

    const [products, setProducts] = useState([]);
    const [searchParams, setSearchParams] = useSearchParams();
    const location = useLocation();
    const [isSortToggled, setIsSortToggled] = useState(false);
    const [isCategoryToggled, setIsCategoryToggled] = useState(false);
    const [isChakraToggled, setIsChakraToggled] = useState(false);
    const [isMonthToggled, setIsMonthToggled] = useState(false);
    const [isPriceToggled, setIsPriceToggled] = useState(false);

    const [categoryOptionsBotanicals, setCategoryOptionsBotanicals] = useState([]);
    const [categoryOptionsCrystals, setCategoryOptionsCrystals] = useState([]);
    const [productBotanicalsSet, setProductBotanicalsSet] = useState(new Set());
    const [productCrystalsSet, setProductCrystalsSet] = useState(new Set());

    const [mobileFiltersToggled, setMobileFiltersToggled] = useState(false);

    const totalProductCount = new Map([
        ["botanicals", 0],
        ["crystals", 0],
        ["all", 0]
    ])
    const [topPrice, setTopPrice] = useState(0);
    const [minSliderRange, setMinSliderRange] = useState(0);
    const [maxSliderRange, setMaxSliderRange] = useState(0);
    const [sliderLeft, setSliderLeft] = useState(0)
    const [sliderRight, setSliderRight] = useState(0)

    const sortingMap = new Map([
        ["relevance", "Relevance"],
        ["price_ascend", "Price (Low - High)"],
        ["price_descend", "Price (High - Low)"],
        ["reviews", "Reviews"],
        ["alphabetical_ascend", "A to Z"],
        ["alphabetical_descend", "Z to A"]
    ])
    const sortingOptionsRef = useRef(null);
    const sorting = searchParams.get("sort") || "relevance";
    const category = searchParams.get("category") || "";
    const chakra = searchParams.get("chakra") || "";
    const month = searchParams.get("month") || "";
    const minPrice = searchParams.get("minPrice") || "";
    const maxPrice = searchParams.get("maxPrice") || "";
    const search = searchParams.get("search") || "";
    const filtersPreJSON = { category, chakra, month, sorting, minPrice, maxPrice, search };

    const pluralToSingleMap = new Map([
        ["categories", "category"],
        ["chakras", "chakra"],
        ["months", "month"],
    ])
    const selectedFilters = {
        categories: category ? category.split(",") : [],
        chakras: chakra ? chakra.split(",") : [],
        months: month ? month.split(",") : [],
        minPrice: minPrice ? minPrice : "",
        maxPrice: maxPrice ? maxPrice : "",
    }
    const selectedCategories = category ? category.split(",") : [];
    const selectedChakras = chakra ? chakra.split(",") : [];

    useEffect(() => {
        const fetchProducts = async () => {
            try {
                const response = await axios.get(`${API_BASE_URL}/api/products`, {
                    params: { category, chakra, month, sorting, minPrice, maxPrice },
                });
                setProducts(search == "" ? response.data : response.data.filter(productInFilter => matchSearch(search, productInFilter.name)))

            } catch (err) {
                console.error("Error fetching products:", err);
            }
        };

        fetchProducts();
    }, [JSON.stringify(filtersPreJSON)]);

    useEffect(() => {
        let cachedScrollY = null;
        const navigationSource = sessionStorage.getItem('navigationSource');
        if (navigationSource === 'product') {
            cachedScrollY = localStorage.getItem('productScrollY');
            sessionStorage.removeItem('navigationSource');
        }
        if (!cachedScrollY) cachedScrollY = localStorage.getItem('cachedScrollY');
        if (cachedScrollY && sessionStorage.getItem('shopSearchParams') === searchParams.toString() && sessionStorage.getItem('shopSearchLocation') === location.pathname) {
            let attempts = 0;
            const maxAttempts = 20;
            let lastDocHeight = document.documentElement.scrollHeight;
            const scrollInterval = setInterval(() => {
                const currentDocHeight = document.documentElement.scrollHeight;
                // Check if DOM has changed (height increased from products rendering)
                if (currentDocHeight > lastDocHeight) {
                    window.scrollTo({ top: Number(cachedScrollY), behavior: 'smooth' });
                    localStorage.removeItem('cachedScrollY');
                    clearInterval(scrollInterval);
                }
                attempts++;
                lastDocHeight = currentDocHeight;
                if (attempts >= maxAttempts) {
                    clearInterval(scrollInterval); // Give up after 20 attempts (~2 seconds)
                }
            }, 100);
        }
        if (sessionStorage.getItem('shopSearchParams') !== searchParams.toString()) {
            sessionStorage.setItem('shopSearchParams', searchParams.toString());
            localStorage.removeItem('cachedScrollY');
        }
        if (sessionStorage.getItem('shopSearchLocation') !== location.pathname) {
            sessionStorage.setItem('shopSearchLocation', location.pathname);
            localStorage.removeItem('cachedScrollY');
        }

    }, [products]);

    useEffect(() => {
        const processProductCategories = async () => {

            try {
                const response = await axios.get(`${API_BASE_URL}/api/categories`);
                if (response.data.length > 0) {
                    const products = response.data;
                    const subcategoryCrystalsSet = new Set();
                    const subcategoryBotanicalsSet = new Set();
                    const crystalsProductSet = new Set();
                    const botanicalsProductSet = new Set();
                    let topProductPrice = 0;
                    // TODO : Create map of id as key with name as value. This will be used as router link for variations
                    for (let product of products) {
                        if (product.price > topProductPrice) topProductPrice = product.price;
                        if (product.category.toLowerCase() === "crystals") {
                            crystalsProductSet.add(product.name)
                            subcategoryCrystalsSet.add(product["subcategory"]);
                        } else if (product.category.toLowerCase() === "botanicals") {
                            botanicalsProductSet.add(product.name)
                            subcategoryBotanicalsSet.add(product["subcategory"])
                        }
                    }
                    setCategoryOptionsBotanicals(Array.from(subcategoryBotanicalsSet))
                    setCategoryOptionsCrystals(Array.from(subcategoryCrystalsSet))
                    setProductBotanicalsSet(botanicalsProductSet)
                    setProductCrystalsSet(crystalsProductSet)
                    setTopPrice(topProductPrice);
                    setMaxSliderRange(topProductPrice);
                    setSliderRight(maxPrice ? maxPrice : topProductPrice);
                    setSliderLeft(minPrice ? minPrice : 0);
                    return () => {
                        console.log("Done")
                    };
                }
            } catch (error) {
                console.error("Error fetching products:", error);

            }
        }
        processProductCategories();

    }, [])

    const handleFilterChange = (filter, value) => {
        const newParams = new URLSearchParams(searchParams);

        if (value) {
            newParams.set(filter, value);
        } else {
            newParams.delete(filter);
        }

        setSearchParams(newParams);
    };

    // Handle multiple category selection
    const handleCategoryChange = (e) => {
        const categoryValue = e.target.value;
        const isChecked = e.target.checked;

        let updatedCategories = [...selectedCategories];
        // let updatedFilters = [...`selected$`]

        if (isChecked) {
            updatedCategories.push(categoryValue); // Add category
        } else {
            updatedCategories = updatedCategories.filter((cat) => cat !== categoryValue); // Remove category
        }

        // Update the category query parameter
        handleFilterChange("category", updatedCategories.join(","));
    };
    const handleFilterUpdate = (e, filter, plural) => {
        const filterValue = e.target.value;
        const isChecked = e.target.checked;

        // const selectedFilters 
        let updatedFilters = [...selectedFilters[plural]];
        // let updatedFilters = [...`selected$`]

        if (isChecked) {
            updatedFilters.push(filterValue); // Add category
        } else {
            updatedFilters = updatedFilters.filter((filt) => filt !== filterValue); // Remove category
        }

        // Update the category query parameter
        handleFilterChange(filter, updatedFilters.join(","));
    };

    return (
        <div style={{ position: "relative" }}>
            <h4 className="shipping-subtitle"><b>Free Shipping on orders over $50! <i style={{ marginLeft: "0.5rem" }} className="bi bi-truck"></i></b></h4>
            <h1 className="centered-subtitle" style={{ marginTop: "2rem" }}>Shop</h1>
            <div id="shopContainer">
                <section className="filters-section" style={{ transform: mobileFiltersToggled ? "translateY(0%)" : "translateY(-200%)", opacity: mobileFiltersToggled ? 1 : 0 }}>
                    <button className="phone-filters-exit" onClick={() => { setMobileFiltersToggled(!mobileFiltersToggled) }}><i className="bi bi-x-lg"></i></button>
                    <h3 className="filters-header">Filter By{searchParams.size == 0 || (searchParams.size == 1 && sorting != "relevance") ? "" : (<button onClick={() => setSearchParams({})}>Clear All</button>)}</h3>
                    <div className="filters-container" style={{ display: "flex", gap: "0.75rem", alignItems: "center", flexWrap: "wrap", margin: "0.5rem 0" }}>
                        {!type ? (<p style={{ margin: 0 }}>All <i className="bi bi-check"></i></p>) : (<Link to="/all">All</Link>)}
                        {type == "botanicals" ? (<p style={{ margin: 0 }}>Botanicals <i className="bi bi-check"></i></p>) : (<Link to="/botanicals">Botanicals</Link>)}
                        {type == "crystals" ? (<p style={{ margin: 0 }}>Crystals <i className="bi bi-check"></i></p>) : (<Link to="/crystals">Crystals</Link>)}
                    </div>

                    <section className="filters-selected-container" style={{ margin: `${searchParams.size == 0 || (searchParams.size == 1 && sorting != "relevance") ? "0rem" : "1rem"} 0px` }}>
                        {searchParams.size == 0 || (searchParams.size == 1 && sorting != "relevance") || (searchParams.size == 1 && search != "") ? "" : (<h3 className="filters-selected-header">Active Filters</h3>)}
                        {Object.keys(selectedFilters).map(filterType => {
                            const filterElements = [];
                            if (!selectedFilters[filterType] || filterType == "minPrice" || filterType == "maxPrice") return;
                            if (selectedFilters[filterType]) {

                                for (let selectedFilter of selectedFilters[filterType]) {

                                    const newElement = React.createElement("article", {
                                        className: "filters-selected-filter", onClick: () => {
                                            const updatedFilters = [...selectedFilters[filterType]].filter((filt) => filt !== selectedFilter)
                                            handleFilterChange(pluralToSingleMap.get(filterType), updatedFilters.join(","))
                                        }
                                    }, (<div><span>{selectedFilter}</span><i className="bi bi-x"></i></div>))
                                    filterElements.push(newElement)
                                }
                            }
                            return filterElements;
                        })}
                        {[selectedFilters["minPrice"], selectedFilters["maxPrice"]].filter(filt => filt != "").map((priceFilter, index) => {
                            if (index == 1) return;
                            const newElement = React.createElement("article", {
                                className: "filters-selected-filter", onClick: () => {
                                    const newParams = new URLSearchParams(searchParams);
                                    newParams.delete("minPrice");
                                    newParams.delete("maxPrice");
                                    setSearchParams(newParams);
                                }
                            }, (<div><span>{`$${searchParams.get("minPrice") ? Number(searchParams.get("minPrice")).toFixed(2) : "0.00"} - $${searchParams.get("maxPrice") ? Number(searchParams.get("maxPrice")).toFixed(2) : maxSliderRange.toFixed(2)}`}</span><i className="bi bi-x"></i></div>))
                            return newElement;
                        })}
                        {/* {Object.keys(selectedFilters).includes("minPrice") || Object.keys(selectedFilters).includes("maxPrice") ?
                            [
                                <article onClick={(e) => {
                                    const newParams = new URLSearchParams(searchParams);
                                    newParams.delete("minPrice");
                                    newParams.delete("maxPrice");
                                    setSearchParams(newParams);
                                    e.currentTarget.remove();
                                }} className="filters-selected-filter"><div><span>${sliderLeft} - ${sliderRight}</span><i className="bi bi-x"></i></div></article>]


                            : (<></>)}
                             */}
                    </section>
                    <section className="criteria-container" >
                        <h3 onClick={() => setIsCategoryToggled(!isCategoryToggled)}>Category<i className="bi bi-chevron-down" style={{ transition: "0.2s all ease", position: "absolute", right: "1rem", top: "1rem", transform: `${isCategoryToggled ? "rotate(180deg)" : "rotate(0deg)"}` }}></i></h3>
                        <span className={`${isCategoryToggled ? "toggled-question" : "untoggled-question"}`}>

                            {!type ? [...categoryOptionsBotanicals, ...categoryOptionsCrystals].map(categoryOption => {
                                return (
                                    <div>
                                        <input
                                            type="checkbox"
                                            value={categoryOption}
                                            checked={selectedCategories.includes(categoryOption)}
                                            onChange={(e) => handleCategoryChange(e)}
                                        ></input>{categoryOption}
                                    </div>
                                )
                            }) : type === "botanicals" ? categoryOptionsBotanicals.map(categoryOption => {
                                return (
                                    <div>
                                        <input
                                            type="checkbox"
                                            value={categoryOption}
                                            checked={selectedCategories.includes(categoryOption)}
                                            onChange={(e) => handleCategoryChange(e)}
                                        ></input>{categoryOption}
                                    </div>
                                )
                            }) : categoryOptionsCrystals.map(categoryOption => {
                                return (
                                    <div>
                                        <input
                                            type="checkbox"
                                            value={categoryOption}
                                            checked={selectedCategories.includes(categoryOption)}
                                            onChange={(e) => handleFilterUpdate(e, "category", "categories")}
                                        ></input>{categoryOption}
                                    </div>
                                )
                            })}
                        </span>
                    </section>
                    {/* <section className="criteria-container" >
                        <h3 onClick={() => setIsChakraToggled(!isChakraToggled)}>Chakra<i className="bi bi-chevron-down" style={{ transition: "0.2s all ease", position: "absolute", right: "1rem", top: "1rem", transform: `${isChakraToggled ? "rotate(180deg)" : "rotate(0deg)"}` }}></i></h3>
                        <span className={`${isChakraToggled ? "toggled-question" : "untoggled-question"}`}>
                            {["Crown", "Third Eye", "Throat", "Heart", "Solar Plexus", "Sacral", "Root", "All"].map((chakraType, index) => {
                                return (
                                    <div>
                                        <input
                                            type="checkbox"
                                            value={chakraType}
                                            checked={selectedFilters["chakras"].includes(chakraType)}
                                            onChange={(e) => handleFilterUpdate(e, "chakra", "chakras")}
                                        ></input>{chakraType}{index != 7 ? <i className="bi bi-circle-fill" style={{ paddingLeft: "0.5rem", color: ["Purple", "Magenta", "Blue", "Green", "Yellow", "Orange", "Red"][index] }}></i> : ""}
                                    </div>
                                );
                            })}
                        </span>
                    </section> */}
                    <section className="criteria-container" >
                        <h3 onClick={() => setIsMonthToggled(!isMonthToggled)}>Month<i className="bi bi-chevron-down" style={{ transition: "0.2s all ease", position: "absolute", right: "1rem", top: "1rem", transform: `${isMonthToggled ? "rotate(180deg)" : "rotate(0deg)"}` }}></i></h3>
                        <span className={`${isMonthToggled ? "toggled-question" : "untoggled-question"}`}>
                            {["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December", "All"].map(monthType => {
                                return (
                                    <div>
                                        <input
                                            type="checkbox"
                                            value={monthType}
                                            checked={selectedFilters["months"].includes(monthType)}
                                            onChange={(e) => handleFilterUpdate(e, "month", "months")}
                                        ></input>{monthType}
                                    </div>
                                );
                            })}
                        </span>
                    </section>
                    <section className="criteria-container" >
                        <h3 onClick={() => setIsPriceToggled(!isPriceToggled)}>Price<i className="bi bi-chevron-down" style={{ transition: "0.2s all ease", position: "absolute", right: "1rem", top: "1rem", transform: `${isPriceToggled ? "rotate(180deg)" : "rotate(0deg)"}` }}></i></h3>
                        <span className={`${isPriceToggled ? "toggled-question" : "untoggled-question"}`}>
                            <div className="price-range-input-container" style={{ display: `${isPriceToggled ? "block" : "none"}` }}>
                                <div className="price-range-input-track" style={{ left: `${(sliderLeft / maxSliderRange) * 100}%`, width: `${(100 - ((sliderLeft / maxSliderRange) * 100)) - (100 - (sliderRight / maxSliderRange) * 100)}%` }}></div>
                                <input
                                    className="price-range-input-min"
                                    type="range"
                                    min={minSliderRange}
                                    max={maxSliderRange}
                                    value={sliderLeft}
                                    step="0.01"
                                    onChange={(e) => { if (Number(e.currentTarget.value) < sliderRight) setSliderLeft(Number(e.currentTarget.value)) }}></input>
                                <input

                                    className="price-range-input-max" type="range"
                                    min={minSliderRange}
                                    max={maxSliderRange}
                                    value={sliderRight}
                                    step="0.01"
                                    onChange={(e) => { if (Number(e.currentTarget.value) > sliderLeft) setSliderRight(Number(e.currentTarget.value)) }}></input>

                            </div>
                            <div className="price-range-container">
                                <div className="price-range-subcontainer">
                                    <label>Min</label>
                                    <input
                                        type="number"
                                        placeholder={minSliderRange}
                                        value={sliderLeft}
                                        step="0.01"
                                        onChange={(e) => { if (Number(e.currentTarget.value) < sliderRight && Number(e.currentTarget.value) >= 0) setSliderLeft(Number(e.currentTarget.value)) }}
                                    ></input>
                                </div>
                                <div className="price-range-subcontainer">
                                    <label>Max</label>
                                    <input
                                        type="number"
                                        placeholder={maxSliderRange}
                                        value={sliderRight}
                                        step="0.01"
                                        onChange={(e) => { if (Number(e.currentTarget.value) > sliderLeft && Number(e.currentTarget.value) <= maxSliderRange) setSliderRight(Number(e.currentTarget.value)) }}

                                    ></input>
                                </div>

                            </div>
                            <div className="price-range-options-container">
                                <button className="price-range-options-primary" onClick={() => {
                                    const newParams = new URLSearchParams(searchParams);
                                    sliderLeft != 0 ? newParams.set("minPrice", sliderLeft) : newParams.delete("minPrice");
                                    sliderRight != maxSliderRange ? newParams.set("maxPrice", sliderRight) : newParams.delete("maxPrice");
                                    setSearchParams(newParams);
                                }}>Apply</button>
                                <button className="price-range-options-secondary" onClick={() => {
                                    const newParams = new URLSearchParams(searchParams);
                                    newParams.delete("minPrice");
                                    newParams.delete("maxPrice");
                                    setSearchParams(newParams);
                                }}>Clear</button>
                            </div>
                        </span>
                    </section>
                    <h3 className="filters-header computer-display">Sort By</h3>

                    <section className="criteria-container computer-display" >
                        <h3 onClick={() => setIsSortToggled(!isSortToggled)}>Sort<i className="bi bi-chevron-down" style={{ transition: "0.2s all ease", position: "absolute", right: "1rem", top: "1rem", transform: `${isSortToggled ? "rotate(180deg)" : "rotate(0deg)"}` }}></i></h3>
                        <span className={`${isSortToggled ? "toggled-question" : "untoggled-question"}`}>
                            {Array.from(sortingMap).map(([key, label]) => (
                                <div key={key}>
                                    <input
                                        type="radio"
                                        name="mobile-sort"
                                        value={key}
                                        checked={sorting === key}
                                        onChange={() => {
                                            if (key === "relevance") handleFilterChange("sort", false);
                                            else handleFilterChange("sort", key);
                                            setMobileFiltersToggled(false);
                                        }}
                                    />{label}
                                </div>
                            ))}
                        </span>
                    </section>
                </section>
                <section className="shop-products">
                    <div className="shop-title-container">
                        {search == "" ? (<h2>{!type ? "Shop All" : `Shop ${type.charAt(0).toUpperCase() + type.slice(1)}`}<span> ({products.filter(product => !type ? true : (product.category).toLowerCase() === type.toLowerCase()).length})</span></h2>) : (<h2> Search for "{search}"<span> ({products.filter(product => !type ? true : (product.category).toLowerCase() === type.toLowerCase()).length})</span></h2>)}
                        <h3 onClick={() => {
                            setIsSortToggled(prev => {
                                const updatedValue = !prev;
                                sortingOptionsRef.current.classList.remove("shop-sort-options-container-untoggled");
                                return updatedValue;
                            }
                            )
                        }} className="shop-sort-container phone-display">Sort by: <span>{sortingMap.get(sorting)} </span><div style={{ transform: `${isSortToggled ? "rotate(180deg)" : "rotate(0deg)"}` }}><i className="bi bi-chevron-down"></i></div>
                            <ul ref={sortingOptionsRef} onTransitionEnd={(e) => { if (!isSortToggled) e.currentTarget.classList.add("shop-sort-options-container-untoggled") }} className="shop-sort-options-container shop-sort-options-container-untoggled" style={isSortToggled ? { opacity: "1", transform: "translateY(0%)" } : { opacity: "0", transform: "translateY(-10%)" }}>
                                <div></div>
                                {Array.from(sortingMap).map(sortingOption =>
                                    sortingOption[0] == sorting ? (<li className={`${sorting == sortingOption[0] ? "selected-sort-option" : ""}`}>{sortingOption[1]}</li>
                                    ) : (<li onClick={() => {
                                        if (sortingOption[0] == "relevance") handleFilterChange("sort", false)
                                        else { handleFilterChange("sort", sortingOption[0]) }
                                    }}>{sortingOption[1]}</li>))}

                            </ul>
                        </h3>{/* Revelance, Price (Low - High), Price (High - Low), Top Rated, Alphabetical (A-Z), Alphabetical (Z-A)*/}
                        <button className="phone-shop-sort-filter computer-display" onClick={() => { setMobileFiltersToggled(!mobileFiltersToggled) }}> Sort and filter <i className="bi bi-filter"></i></button>
                        <div>Showing <span>{products.filter(product => !type ? true : (product.category).toLowerCase() === type.toLowerCase()).length}</span> out of <span>{products.filter(product => !type ? true : (product.category).toLowerCase() === type.toLowerCase()).length}</span> results</div>
                    </div>

                    {products.filter(product => !type ? true : (product.category).toLowerCase() === type.toLowerCase()).filter(product => product.quantity != 0).map((product) => {
                        const splitName = product.name.split("(");
                        let totalRating = 0;
                        let totalRatingUsers = 0;
                        for (let rating in product.reviews) {
                            const ratingArray = product.reviews[rating];
                            totalRating = totalRating + (Number(rating) * ratingArray.length);
                            totalRatingUsers = totalRatingUsers + ratingArray.length;
                        }
                        const reviewIcons = [];
                        for (let i = 0; i < 5; i++) {
                            const avgRating = (totalRating == 0 && totalRatingUsers == 0) ? 0 : totalRating / totalRatingUsers;
                            const starName = avgRating < (i + .24) ? "bi-star" : avgRating < (i + .74) && avgRating > (i + .24) ? "bi-star-half" : "bi-star-fill";
                            const starIcon = React.createElement("i", { className: `star-icons bi ${starName}` });
                            reviewIcons.push(starIcon);
                        }

                        return (
                            <div className="card-item-shop" key={product._id}>
                                {/* <button className='card-button-cart-shop' onClick={() => { addToCart(product) }}><div><i className="bi bi-cart-plus"></i></div></button> */}
                                <Link className="card-link-overlay" to={`/product/${product.name}`} onClick={() => {
                                    localStorage.setItem('productScrollY', window.scrollY);

                                }}>
                                </Link>
                                <img className="card-shop-image" loading="lazy" src={`${product?.imageURL?.[0]?.includes('/upload/') ? product.imageURL[0].replace("/upload/", '/upload/c_fit,w_360/') : placeholderImage}`} ></img>
                                <div className="card-item-details-container">
                                    <div>
                                        <h3>{splitName[0]}</h3>
                                        <i>{splitName?.[1]?.replace(")", "")}</i>
                                    </div>
                                    <div>
                                        <div>{reviewIcons}{(totalRating == 0 && totalRatingUsers == 0) ? " Not yet rated" : ` (${totalRating / totalRatingUsers}) ${totalRatingUsers} rating${totalRatingUsers > 1 ? "s" : ""}`}</div>
                                        <p>${product.price}</p>
                                        {cart.some(cartItem => cartItem?.["_id"] == product?.["_id"])
                                            ? (
                                                <div className="card-cart-details-container">
                                                    <div className="cart-products-item-input-container">
                                                        <button onClick={() => {
                                                            updateQuantity(product["_id"], (cart.find(cartItem => cartItem?.["_id"] == product?.["_id"])["quantity"] - 1))
                                                        }} className={`${cart.find(cartItem => cartItem?.["_id"] == product?.["_id"])["quantity"] == 1 ? "cart-products-item-input-button-disabled" : ""}`}><i className="bi bi-dash-lg"></i></button>
                                                        <p>{cart.find(cartItem => cartItem?.["_id"] == product?.["_id"])["quantity"]}</p>
                                                        <button onClick={() => {
                                                            addToCart(cart.find(cartItem => cartItem?.["_id"] == product?.["_id"]))
                                                        }} className={`${product.quantity == cart.find(cartItem => cartItem?.["_id"] == product?.["_id"])["quantity"] ? "cart-products-item-input-button-disabled" : ""}`}>
                                                            <i className="bi bi-plus-lg"></i>
                                                        </button>
                                                    </div>
                                                    <button className="card-cart-remove-button" onClick={() => {
                                                        removeFromCart(product._id)
                                                    }}>
                                                        <i className="bi bi-trash"></i>
                                                    </button>
                                                </div>
                                            )
                                            :
                                            (<button className='card-button-cart-shop' onClick={() => { addToCart(product) }}>Add to cart <i className="bi bi-cart-plus"></i></button>)}
                                    </div>
                                </div>
                            </div>
                        )
                    })}

                    {products.filter(product => !type ? true : (product.category).toLowerCase() === type.toLowerCase()).filter(product => product.quantity == 0).map((product) => {
                        const splitName = product.name.split("(");
                        let totalRating = 0;
                        let totalRatingUsers = 0;
                        for (let rating in product.reviews) {
                            const ratingArray = product.reviews[rating];
                            totalRating = totalRating + (Number(rating) * ratingArray.length);
                            totalRatingUsers = totalRatingUsers + ratingArray.length;
                        }
                        const reviewIcons = [];
                        for (let i = 0; i < 5; i++) {
                            const avgRating = (totalRating == 0 && totalRatingUsers == 0) ? 0 : totalRating / totalRatingUsers;
                            const starName = avgRating < (i + .24) ? "bi-star" : avgRating < (i + .74) && avgRating > (i + .24) ? "bi-star-half" : "bi-star-fill";
                            const starIcon = React.createElement("i", { className: `star-icons bi ${starName}` });
                            reviewIcons.push(starIcon);
                        }

                        return (
                            <div className="card-item-shop" key={product._id}>
                                <div className="card-out-of-stock-overlay"></div>
                                <Link className="card-link-overlay" to={`/product/${product._id}`}>
                                </Link>
                                {/*
                                q_50
                                13.3 MB transferred
                                17.6 MB resources*/}
                                <img className="card-shop-image" style={{ filter: "grayscale(1)" }} loading="lazy" src={`${product?.imageURL?.[0]?.includes('/upload/') ? product.imageURL[0].replace("/upload/", '/upload/c_fit,w_480/') : placeholderImage}`} ></img>

                                <div className="card-item-details-container">

                                    <div>
                                        <h3>{splitName[0]}</h3>
                                        <i>{splitName?.[1]?.replace(")", "")}</i>
                                    </div>

                                    <div>
                                        <div>{reviewIcons}{(totalRating == 0 && totalRatingUsers == 0) ? " Not yet rated" : ` (${totalRating / totalRatingUsers}) ${totalRatingUsers} rating${totalRatingUsers > 1 ? "s" : ""}`}</div>
                                        <p>${product.price}</p>
                                        <h4 style={{ color: "red", padding: "0.5rem", marginTop: "0.5rem" }}>OUT OF STOCK</h4>

                                    </div>
                                </div>
                            </div>
                        )
                    })}
                </section>
            </div>


        </div >
    );
}

export default Shop;